import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpInterceptorModule } from './interceptors/HttpInterceptor.module';
import { PipesModule } from './shared/pipes/pipes.module';
import { ToolkitModule } from './shared/toolkit/toolkit.module';
import { IdsConfigModule } from '@ids/angular';
import { Segments } from '@ids/tools';
import { IpbLoadingModule } from '@shared/components/loading/ipb-loading.module';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule.forRoot(appRoutes),
		IdsConfigModule.forRoot({
			production: environment.production,
			segment: Segments.Private,
		}),
		HttpInterceptorModule,
		HttpClientModule,
		ToolkitModule,
		IpbLoadingModule
	],
	exports: [PipesModule],
	bootstrap: [AppComponent],
})
export class AppModule {}
// export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
// 	return new TranslateHttpLoader(http);
// }
